'use client';
import { useEffect, useState } from 'react';

import Container from '@/components/@base/container';
import { CONTAINER_TAG_TYPE } from '@/components/@base/container/type';
import { Text } from '@/components/@base/typography';
import Props, {
  CountdownTimeLeft,
} from '@/components/app/product/components/discount-countdown/timer/type';

const INITIAL_TIME_LEFT = {
  hrs: 0,
  mins: 0,
  secs: 0,
};
export default function Timer({ deadline }: Props) {
  const [timeLeft, setTimeLeft] = useState<CountdownTimeLeft>(INITIAL_TIME_LEFT);

  useEffect(() => {
    setTimeLeft(calcCountdownTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calcCountdownTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  function calcCountdownTimeLeft(): CountdownTimeLeft {
    let timeLeft: CountdownTimeLeft = {};
    let currentDate = new Date();
    let difference = deadline.getTime() - currentDate.getTime();

    if (difference > 0) {
      timeLeft = {
        hrs: Math.floor(difference / (1000 * 60 * 60)),
        mins: Math.floor((difference / 1000 / 60) % 60),
        secs: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  }

  return (
    <Container center className='flex-row-reverse gap-1 text-base font-bold text-[#544C45]'>
      {Object.entries(timeLeft)?.map(([unit, value], index) => (
        <Container key={unit} center className='gap-1'>
          <Text>{`${value}`.padStart(2, '0')}</Text>

          {index !== 0 && <Container type={CONTAINER_TAG_TYPE.SPAN}>:</Container>}
        </Container>
      ))}
    </Container>
  );
}
